// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"212":"e720bcad16bdc777baee","965":"78f23aa9bef300cbd8f2"}[chunkId] + ".js";
};